import React from 'react';
import { ProgressBarFill, ProgressBarWrapper } from './ProgressBar.styles';
import { Tenant } from '../../config/tenants';
import { useIsTenant } from '../../config/utils/useIsTenant';
import { useCalculatedProgress } from './ProgressBar.utils';

export const ProgressBar = (): JSX.Element | null => {
  const calculatedProgress = useCalculatedProgress();
  const isInterrisk = useIsTenant(Tenant.INTER_RISK);
  const isTuw = useIsTenant(Tenant.TUW);

  if (!isInterrisk && !isTuw) return null;

  return (
    <ProgressBarWrapper>
      <ProgressBarFill progress={calculatedProgress} />
    </ProgressBarWrapper>
  );
};
